<div class="card">
  <div class="card-header p-2">
    <button class="btn btn-primary btn-sm btn-floating float-end m-0" (click)="openBaujournalOverview()">
      <i class="fal fa-list-ul" aria-hidden="true"></i>
    </button>
    <button class="btn btn-primary btn-sm btn-floating float-end m-0 me-1" (click)="createBaujournal()">
      <i class="fal fa-plus" aria-hidden="true"></i>
    </button>
    <h4 class="card-title mb-0 mt-1">
      <i class="fal fa-book" aria-hidden="true"></i>
      Baujournal
    </h4>
  </div>
  @if (!data) {
    <div class="card-body b2-card pe-2"></div>
  }
  @if (data) {
    <div
      class="card-body b2-card pe-2 hand"
      tabindex="0"
      (click)="openBaujournalOverview()"
      (keydown.enter)="openBaujournalOverview()"
    >
      <div class="card-text">
        <div>{{ data.dokument }}</div>
        <div>{{ data.bezeichnung }}</div>
        @if (getBauherr(data)) {
          <div class="projekt-bauherr">
            <i class="fal fa-user" aria-hidden="true"></i>
            &nbsp;{{ getBauherr(data) }}
          </div>
        }
      </div>
    </div>
  }
</div>
